import styled from 'styled-components'
import { Box, Typography } from 'src/components'
import { Link } from 'react-router-dom'

export const OverCard = styled(Box)`
    width: 80%;
    flex: 0 0 auto;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 40%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        flex: 0 0 auto;
        width: 30%;
    }
`
export const Card = styled(Link)`
    cursor: pointer;
    color: ${({ theme }) => theme.colors.white};
    min-height: 400px;
    box-shadow: 0 8px 26px -4px #14141426, 0 8px 9px -5px #1414140f !important;
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background: ${({ theme }) => theme.colors.lineaGradiant};
    background-clip: border-box;
    border: 0 solid rgba(0, 0, 0, 0.125);
    border-radius: 1rem;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        min-height: 430px;
        box-shadow: 0 8px 26px -4px #14141426, 0 8px 9px -5px #1414140f !important;
        position: relative;
        display: flex;
        flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        background: ${({ theme }) => theme.colors.lineaGradiant};
        background-clip: border-box;
        border: 0 solid rgba(0, 0, 0, 0.125);
        border-radius: 1rem;
    }
`
export const HeaderCard = styled.a`
    letter-spacing: -0.025rem;
    text-decoration: none;
    padding: 1rem !important;
    box-sizing: border-box;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`

export const Image = styled.img`
    height: 190px;
    width: 100% !important;
    border-radius: 0.5rem;
    background: ${({ theme }) => theme.colors.darkGrey};
    vertical-align: middle;
    box-sizing: border-box;
    object-fit: contain;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        height: 220px;
    }
`
export const ContentData = styled(Box)`
    padding: 1.25rem 2rem;
    font-family: inherit;
    border-radius: 0.5rem;
    box-shadow: inset 0 0 2px #fefefed1;
    -webkit-backdrop-filter: saturate(200%) blur(30px);
    backdrop-filter: saturate(200%) blur(30px);
    background: ${({ theme }) => theme.colors.hamburger};
    margin-top: -3rem;
    margin-right: 1.5rem;
    margin-left: 1.5rem;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    display: flex;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const TitleSection = styled(Typography)`
    font-family: inherit;
    text-align: center;
    height: 60px;
    display: flex;
    align-items: center;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        height: 50px;
        line-height: 25px;
    }
`
export const ContentSection = styled(Typography)`
    text-align: center;
    height: 40px;
    font-family: inherit;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        height: 45px;
        line-height: 21px;
    }
`
export const ContentIcons = styled(Box)`
    width: 70%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`

export const Icon = styled.img`
    flex: 0 0 auto;
    padding-right: 0.8rem;
    cursor: pointer;
    padding-left: 0.8rem;
    width: 30px;
    height: 30px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
